import React from 'react';
import Contact from '../../components/Message/Contact';

const ContactWindow = (props) => {

    const classList = ['contact-window'];
    if (props.open) {
        classList.push(['contact-window--open'])
    }

    let contacts = <p className="contact-list__empty">No Contacts</p>

    if (props.contacts.length > 0) {
        contacts = props.contacts.map(contact => {
            return <Contact
                key={contact.userId}
                name={contact.firstName}
                isActive={contact.userId === props.activeContactUserId}
                profilePicture={contact.profilePicture}
                lastMessage={contact.lastMessage.text}
                hasUnreadMessage={!contact.lastMessage.isRead}
                clicked={() => props.contactClicked(contact.userId)} />
        });
    }

    return <div className={classList.join(' ')} onClick={props.closed}>
        <div className="contacts">
            {contacts}
        </div>
    </div>
}

export default ContactWindow;